module.exports = "/_next/static/images/c8b642681887fc5490158e8ee7d30915-savingsbanner-lg-2x.jpg.webp";